<template lang="pug">
  .lista-solicitud-vacaciones.contenedor-interno
    .title
      span Solicitudes por aprobar
      span.icon.close(
        @click="$emit('close')"
      )
        i.fa.fa-close

    transition(
      name='fade',
      tag="div",
      v-if="mostrarConfirmacionAprobar"
      )
      confirmar-accion-overlay(
        @close="mostrarConfirmacionAprobar = false"
        @do="aprobar"
        ref="confirmarAprobar"
      )
        span(slot="title") ¿Desea aprobar la solicitud?
        span(slot="primaryAction") Aprobar

    transition(
      name='fade',
      tag="div",
      v-if="mostrarConfirmacionRechazar"
      )
      confirmar-accion-overlay(
        @close="mostrarConfirmacionRechazar = false"
        @do="rechazar"
        ref="confirmarRechazar"
      )
        span(slot="title") ¿Desea rechazar la solicitud?
        span(slot="primaryAction") Rechazar

    .body
      loading(v-if="isLoading")
      table.table.is-striped.is-bordered(v-else)
        thead
          th Empleado
          th.hide-break-2 Tipo renovación
          th Estado
          th.hide-break-2 Creado por
          th Acciones
        tbody(
          name="table-row"
          is="transition-group"
        )
          tr.row-table(
            v-for="o in lista"
            :key="o.id+'-tabla'"
            :class="{ 'row-info': o.esDeDelegacion }"
          )
            td
              .flex.aic
                  span.hint--top.margin-right-5(:aria-label="'Solicitud Delegada'",v-if="o.esDeDelegacion")
                    i.fa.fa-exclamation-circle
                  .td-wrapper.hint--right(:aria-label="'Empleado: ' + o.dniEmpleado")
                    .dates-wrapper.hint--bottom(:aria-label="'Solicitud: ' + o.id")
                      //- span.has-text-bold {{ o.codigo }}&nbsp;
                      span {{ o.nombre }}&nbsp;
                    div.show-break-2.dates-wrapper
                      span.has-text-bold Renovacion:
                      span(v-if="o.indeterminado") Contrato Indeterminado
                      span(v-else) {{ o.meses }} meses
                    div.show-break-2.dates-wrapper
                      span.has-text-bold Creador:
                      span {{ o.creadoPor }}

            td.hide-break-2
              span(v-if="o.indeterminado") Contrato Indeterminado
              span(v-else) {{ o.meses }} meses
            td {{ o.descripcionEstado }}
            td.hide-break-2 {{ o.creadoPor }}
            td
              .contenedor-acciones(v-if="o.estado === 1")
                button.button.is-small(@click="confirmarAprobar(o)")
                  span.icon.is-small
                    i.fa.fa-thumbs-o-up
                  span Aprobar
                button.button.is-small.is-danger(@click="confirmarRechazo(o)")
                  span.icon.is-small
                    i.fa.fa-times
                  span Rechazar
</template>

<script>
import ConfirmarAccionOverlayComponent from './Component_Confirmar_Accion_Overlay'
import { apiGet, apiPost, apiDelete, notify } from '../util/general'
import { scrollTo } from '../util/scroll'
export default {
  name: 'lista_solicitud_vacaciones_por_aprobar_component',
  data () {
    return {
      lista: [],
      mostrarConfirmacionAprobar: false,
      mostrarConfirmacionRechazar: false,
      solicitudSeleccionada: {},
      isLoading: false
    }
  },
  components: {
    'confirmar-accion-overlay': ConfirmarAccionOverlayComponent
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {}
      apiGet(vm, '/contratos/solicitud/poraprobar', obj, function (data) {
        if (data.lista.length === 0) {
          vm.$emit('close')
        }

        vm.lista = data.lista
        // esto replica la lista 3 veces
        // vm.lista.push(...data.lista.map(obj => ({...obj, id: obj.id + 100})));
        // vm.lista.push(...data.lista.map(obj => ({...obj, id: obj.id + 200})));
        // vm.lista.push(...data.lista.map(obj => ({...obj, id: obj.id + 300})));
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    enterEditMode (o) {
      this.solicitudSeleccionada = o
      this.isEditing             = true
    },
    confirmarAprobar (o) {
      this.solicitudSeleccionada = o
      this.mostrarConfirmacionAprobar = true
      this.$nextTick(() => {
        scrollTo({
          ref: this.$refs.confirmarAprobar.$el,
          vm: this,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        })
      })
    },
    confirmarRechazo (o) {
      this.solicitudSeleccionada = o
      this.mostrarConfirmacionRechazar = true
      this.$nextTick(() => {
        scrollTo({
          ref: this.$refs.confirmarRechazar.$el,
          vm: this,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        })
      })
    },
    aprobar () {
      var vm = this
      var obj = {
        id: vm.solicitudSeleccionada.id
      }
      apiPost(vm, '/contratos/solicitud/renovacion/aprobar', obj, function (data) {
        vm.mostrarConfirmacionAprobar = false
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    rechazar () {
      var vm = this

      var obj = {
        id: this.solicitudSeleccionada.id
      }

      apiDelete(vm, '/contratos/solicitud/renovacion', obj, function (data) {
        vm.mostrarConfirmacionRechazar = false
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    seleccionarEmpleadoParaReemplazo (o, empleado) {
      // Primero guardamos esto
      var vm = this
      var obj = {
        id: o.id,
        codigoEmpleadoReemplazante: empleado.codigo
      }
      apiPost(vm, '/vacaciones/solicitud/reemplazo', obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Se asigno el empleado de reemplazo correctamente')
        o.codigoEmpleadoReemplazante = empleado.codigo
        o.nombreEmpleadoReemplazante = empleado.nombre
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-interno
    .close
      position absolute
      top 3px
      right 3px
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .contenedor-acciones
    display flex
    .button
      flex 1
      margin 0px 5px

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }


  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    width: 300px;
    z-index: 70;
    top 0



  .quitar
    margin-left 5px
    cursor pointer
    i
      font-size 15px
  .show-break-1
    display none

  .show-break-2
    display none

  @media (max-width 902px)
    .table
      font-size 12px
      td
        text-align: center
        vertical-align: middle
      .td-wrapper
        display flex
        justify-content: center
        align-items: center
        flex-direction: column

        // .dates-wrapper
        //   display: flex
        //   flex-direction: column


    .show-break-1
      display initial

    .hide-break-1
      display none


  @media (max-width 663px)
    .show-break-2
      display initial

    .hide-break-2
      display none
    .dates-wrapper
      display: flex
      flex-direction: column
    .contenedor-acciones
      display flex
      flex-direction: column
      gap: 10px
      margin-top 10px

    .pop-over
      right 0px

</style>



// WEBPACK FOOTER //
// Component_Contratos_Lista_Solicitud_Renovacion_Contrato_Por_Aprobar.vue?65b71cf2